import { forwardRef } from 'react';

const VARIANT_CLASS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
};

const Button = forwardRef(function Button(
  { children, variant = 'primary', className = '', disabled = false, type = 'button', ...rest },
  ref,
) {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={`${variantClass} min-h-[44px] inline-flex items-center justify-center ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
});

export default Button;
